export default __webpack_public_path__ + "1e55a76b68a72fe84d60643a52c74b3b.svg";